import React from "react";
import { Modal } from "react-bootstrap";

import styles from "./resultModalText.module.css";

const ResultModalText = ({ show, handleClose, text, headerName }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header className={styles["form-header"]} closeButton>
        {headerName}
      </Modal.Header>
      <Modal.Body className={styles["form-body"]}>{text}</Modal.Body>
    </Modal>
  );
};

export default ResultModalText;
